import React from "react";
import StoreCommissioningPage from "./StoreCommissioningPage.js";
import apiProxy from "../../api/apiProxy";
import { forkJoin, of, BehaviorSubject, combineLatest } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { componentFromStream } from "recompose";
import withLoadingAndErrorHandling from "../../utils/reactive/wrapPageApiCall.js";
import withCommissionedLightingStores from "../WithCommissionedLightingStores";

const StoreCommissioningPageWithData = componentFromStream(props$ => {
  const fetchTrigger$ = new BehaviorSubject(null);

  const triggerFetch = onLightingStoresChange => {
    fetchTrigger$.next();
    onLightingStoresChange();
  };

  return withLoadingAndErrorHandling(() =>
    combineLatest([props$, fetchTrigger$]).pipe(
      mergeMap(([props]) =>
        forkJoin([
          props.getStore(props.storeId),
          props.getScenes(),
          of(props.pathName),
          of(props.onLightingStoresChange)
        ])
      ),
      map(([store, scenes, pathName, onLightingStoresChange]) => (
        <StoreCommissioningPage
          store={store}
          scenes={scenes}
          pathName={pathName}
          completeCommissioning={apiProxy.storeLighting.completeCommissioning}
          onZoneDelete={() => triggerFetch(onLightingStoresChange)}
          onLightingStoresChange={onLightingStoresChange}
        />
      ))
    )
  );
});

export default withCommissionedLightingStores(props => (
  <StoreCommissioningPageWithData
    storeId={props.match.params.storeId}
    getStore={apiProxy.storeLighting.getStore}
    getScenes={apiProxy.scene.getScenes}
    pathName={props.location.pathname}
    onLightingStoresChange={props.onLightingStoresChange}
  />
));
